import React from 'react'

import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers'

import { input } from '@albacross/frontend-utils'

type DateTimePickerProps = {
  value: any
  onChange: (...args: any[]) => any
  disabled?: boolean
  errorId?: string | boolean
  fullWidth?: boolean
  label?: string
}

const DateTimePicker = ({
  value,
  onChange,
  disabled = false,
  errorId,
  fullWidth = true,
  label = '',
}: DateTimePickerProps) => (
  <MuiDateTimePicker
    disabled={disabled}
    format="yyyy-MM-dd HH:mm"
    label={label}
    onChange={onChange}
    slotProps={{ textField: { error: !!errorId, fullWidth, helperText: errorId } }}
    value={value ? new Date(value) : null}
  />
)

export default input('')(DateTimePicker)
